import React from "react";
import AccountIcon from "@icons/myicons/sidebar/accounts.svg?react";
import AccountIconSelected from "@icons/myicons/sidebar/accounts-selected.svg?react";
import CashbackIcon from "@icons/myicons/sidebar/analyzer.svg?react";
import CashbackIconSelected from "@icons/myicons/sidebar/analyzer-selected.svg?react";
import HomeIcon from "@icons/myicons/sidebar/home.svg?react";
import HomeIconSelected from "@icons/myicons/sidebar/home-selected.svg?react";
import InvestmentsIcon from "@icons/myicons/sidebar/investments.svg?react";
import InvestmentsIconSelected from "@icons/myicons/sidebar/investments-selected.svg?react";
import CashflowAnalyzerIcon from "@icons/myicons/sidebar/cashflow-analyzer.svg?react";
import CashflowAnalyzerIconSelected from "@icons/myicons/sidebar/cashflow-analyzer-selected.svg?react";
import GoalsIcon from "@icons/myicons/sidebar/goals.svg?react";
import GoalsIconSelected from "@icons/myicons/sidebar/goals-selected.svg?react";
import QuestionnaireIcon from "@icons/myicons/sidebar/questionnaire-icon.svg?react";
import QuestionnaireIconSelected from "@icons/myicons/sidebar/questionnaire-icon-selected.svg?react";

export const sidebarIcons = {
  accounts: <AccountIcon />,
  accountsSelected: <AccountIconSelected />,
  cashback: <CashbackIcon />,
  cashbackSelected: <CashbackIconSelected />,
  home: <HomeIcon />,
  homeSelected: <HomeIconSelected />,
  investments: <InvestmentsIcon />,
  investmentsSelected: <InvestmentsIconSelected />,
  cashflowAnalyzer: <CashflowAnalyzerIcon />,
  cashflowAnalyzerSelected: <CashflowAnalyzerIconSelected />,
  goals: <GoalsIcon />,
  goalsSelected: <GoalsIconSelected />,
  questionnaire: <QuestionnaireIcon />,
  questionnaireSelected: <QuestionnaireIconSelected />,
};
